let title = "Yext Content+";
let learnUrls = {};

export default {
    title, learnUrls,
    legalEntityShort: "Yext",
    legalEntityFull: "Yext, Inc",
    privacyPolicyUrl: 'https://www.yext.com/privacy-policy',
    termsOfUseUrl: 'https://www.yext.com/terms',
    infoEmail: '',
    marketingSiteUrl: '',
    feedsDomain: 'feeds.content.hearsaysocial.com',
    shortenerDomain: 'go.content.hearsaysocial.com',
    hideSubscription: true,
    hideSupportApps: true,
    hideShare: true,
    hideZapier: true,
    hideIntegrations: true,
    hideGalleries: true,
    hideContentTemplates: true,
    hideFeedLink: true,
}
